import {SidePanelRoot} from './SidePanelRoot'
import {Toc} from './Toc'

export {PanelSizeEnum} from './parts/Panel'

export const SidePanel = Object.assign(SidePanelRoot, {
  Toc,
})
